module.exports = __webpack_public_path__ + "img/404.dd481af3.jpg";